document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('#krf-redirect-btn-1, #krf-redirect-btn-2');
  const currentCustomerTagsElement = document.getElementById('krf-customer-tags');

  if (!buttons.length) return;

  const currentLocale = (window.Shopify && Shopify.locale && Shopify.locale !== 'fr')
    ? '/' + Shopify.locale
    : '';

  buttons.forEach(button => {
    const defaultButtonText = button.getAttribute('data-button-text') || 'Voir mon profil';
    const buttonTextForTags = button.getAttribute('data-button-text-2') || 'Voir mon profil';

    if (currentCustomerTagsElement) {
      const currentCustomerTags = currentCustomerTagsElement.value.trim();

      if (currentCustomerTags) {
        const pageRouteCustomerTagMap = {
          'le pépin voyageur': 'le-pepin-voyageur',
          'le raisin vif': 'le-raisin-vif',
          'le cep tranquille': 'le-cep-tranquille',
          'la vrille curieuse': 'la-vrille-curieuse',
          'la grappe joyeuse': 'la-grappe-joyeuse',
        };

        const customerTagKeys = Object.keys(pageRouteCustomerTagMap).map(tag => tag.toLowerCase());
        const customerTagsArray = currentCustomerTags.split(',').map(tag => tag.trim().toLowerCase());

        const customerTag = customerTagsArray.find(tag => customerTagKeys.includes(tag));
        const wineProfilePath = customerTag ? pageRouteCustomerTagMap[Object.keys(pageRouteCustomerTagMap).find(key => key.toLowerCase() === customerTag)] : null;

        const hasLessThan40Tag = customerTagsArray.some(tag => !isNaN(tag) && Number(tag) < 35);

        if (wineProfilePath) {
          const finalPath = hasLessThan40Tag
            ? `${currentLocale}/pages/${wineProfilePath}-v1`
            : `${currentLocale}/pages/${wineProfilePath}-v2`;

          button.setAttribute('href', finalPath);
          button.textContent = buttonTextForTags;
        } else {
          button.setAttribute('href', `${currentLocale}/pages/wine-profile-not-found`);
          button.textContent = buttonTextForTags;
        }
      } else {
        button.setAttribute('href', `${currentLocale}/pages/wine-profile-not-found`);
        button.textContent = defaultButtonText;
      }
    } else {
      button.setAttribute('href', `${currentLocale}/pages/quiz`);
      button.textContent = defaultButtonText;
    }
  });
});